






















import {
  computed,
  defineComponent,
  PropType,
  ref,
  SetupContext,
  watch,
} from "@vue/composition-api";
import ButtonGenericV2 from "../buttons/button-generic-v2.vue";
import { IBaseConcreteDropDown } from "./field-models";
import { simpleClone } from "../../../common-service-utils";

/**
 * Exmaple usage
 *
 <FieldSelectV2 :data-array="clubCompCategories" v-model="clubCompDefinitionInternal.category">
  <template slot-scope="{obj}">
    {{obj.categoryName}}
  </template>
 </FieldSelectV2>
 *
 */
export default defineComponent({
  name: "field-select-v2",
  components: { ButtonGenericV2 },
  inheritAttrs: false,
  props: {
    // formLabel: {
    //   type: String,
    //   default: () => {
    //     return "";
    //   },
    // },
    placeHolder: {
      type: String,
      default: () => {
        return "";
      },
    },
    value: {
      type: Object as PropType<IBaseConcreteDropDown>,
      default: () => {
        return {
          id: 0,
          name: "",
        };
      },
    },
    errorMessage: {
      type: String,
      default: () => {
        return "";
      },
    },
    dataArray: {
      type: Array as PropType<IBaseConcreteDropDown[]>,
      default: () => {
        return [];
      },
    },
    allowValueNotInArray: {
      type: Boolean,
      default: true,
    },
    debugConsole: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isRequiredField: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  setup(
    props: {
      value: IBaseConcreteDropDown;
      placeHolder: string;
      errorMessage: string;
      dataArray: IBaseConcreteDropDown[];
      allowValueNotInArray: boolean;
      debugConsole: string;
      isRequiredField: boolean;
    },
    context: SetupContext
  ) {
    const valueInternal = ref(simpleClone(props.value));
    const dataArrayInternal = ref(simpleClone(props.dataArray));

    watch(
      () => props.value,
      (newValue: IBaseConcreteDropDown) => {
        if (newValue !== valueInternal.value) {
          console.log("field-drop-down-v2 value changed", {
            new: newValue,
            internal: valueInternal.value,
          });

          if (props.debugConsole.length > 0) {
            console.warn(
              "DEBUG FieldSelectV2 watch(value) [" +
                props.debugConsole +
                "] props.value:",
              {
                new: newValue,
                internal: valueInternal.value,
              }
            );
          }

          valueInternal.value = newValue;
          setDefault();
        }
      },
      {
        immediate: true,
      }
    );

    watch(
      () => props.dataArray,
      (newValue: IBaseConcreteDropDown[]) => {
        dataArrayInternal.value = simpleClone(newValue);
        setDefault();
      },
      {
        immediate: true,
      }
    );

    function setDefault() {
      //  Loop through the data array and if the id matches the value, set it

      if (props.debugConsole.length > 0) {
        console.warn(
          "DEBUG FieldSelectV2.setDefault() [" +
            props.debugConsole +
            "] props.value:",
          props.value
        );
      }

      let defaultValue = simpleClone(props.value);
      let defaultFound = false;
      let dataArrayInt = simpleClone(props.dataArray);

      for (let i = 0; i < dataArrayInt.length; i++) {
        if (dataArrayInt[i].id === props.value.id) {
          defaultValue = dataArrayInt[i];
          defaultFound = true;
          dataArrayInternal.value = simpleClone(dataArrayInt);
          valueInternal.value = defaultValue;
          //  All good...set the value and return
          return;
        }
      }

      if (props.debugConsole.length > 0) {
        console.warn(
          "DEBUG FieldSelectV2.setDefault() [" +
            props.debugConsole +
            "]  defaultFound: " +
            defaultFound
        );
      }

      console.warn("DEBUG setDefault", props.value);

      if (!props.allowValueNotInArray) {
        if (props.debugConsole.length > 0) {
          console.warn(
            "DEBUG FieldSelectV2.setDefault() [" +
              props.debugConsole +
              "]  allowValueNotInArray: " +
              props.allowValueNotInArray +
              ", exit."
          );
        }

        dataArrayInternal.value = simpleClone(dataArrayInt);
        valueInternal.value = defaultValue;
        return;
      }

      if (!defaultFound && props.allowValueNotInArray) {
        if (props.debugConsole.length > 0) {
          console.warn(
            "DEBUG FieldSelectV2.setDefault() [" +
              props.debugConsole +
              "]  allowValueNotInArray: " +
              props.allowValueNotInArray +
              ", default value not found, insert it at the beginning."
          );
        }

        // If the default value is not found, insert it at the beginning
        dataArrayInt.unshift(defaultValue);
        dataArrayInternal.value = simpleClone(dataArrayInt);
        valueInternal.value = dataArrayInternal.value[0];
        return;
      }

      if (props.debugConsole.length > 0) {
        console.warn(
          "DEBUG FieldSelectV2.setDefault() [" +
            props.debugConsole +
            "]  allowValueNotInArray: " +
            props.allowValueNotInArray +
            ", default value found."
        );
      }
      dataArrayInternal.value = simpleClone(dataArrayInt);
    }

    function onChanged() {
      if (typeof valueInternal.value === "undefined") {
        return;
      }
      context.emit("input", valueInternal.value);
      context.emit("onChange", valueInternal.value);
    }

    // errorMessage.length > 0 ? 'e4s-input-field--error' : ''

    const cssClasses = computed(() => {
      const css: string[] = [];

      if (props.errorMessage.length > 0) {
        css.push("e4s-input-field--error");
        return css;
      }

      props.isRequiredField
        ? css.push("e4s-input-field--required")
        : css.push("e4s-input-field--optional");

      return css;
    });

    return { valueInternal, dataArrayInternal, cssClasses, onChanged };
  },
});
